import styled from 'styled-components'

export const StyledBillingInfo = styled.div`
	margin-top: 4rem;
	margin-bottom: 4rem;
	font-size: 16px;

	.options {
		display: flex;
		align-items: center;
		margin-bottom: 5px;

		& > :first-child {
			margin-right: 10px;
		}
	}

	ul {
		padding-left: 0;
	}

	li {
		font-weight: normal;
		list-style: none;
	}
`
